import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import DiscoveryConfigListLayer from "../../components/DiscoveryConfig/DiscoveryConfigListLayer";


const DiscoveryConfigListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Compatibility Algorithm" />

        {/* UsersListLayer */}
        <DiscoveryConfigListLayer />

      </MasterLayout>

    </>
  );
};

export default DiscoveryConfigListPage; 
